import React, { ComponentProps, FC, ReactNode } from 'react';
import { PlcCell } from '@layout/components/PlcTable/PlcCell';
import { PlcHeaderCell } from '@layout/components/PlcTable/PlcHeaderCell.component';
import classnames from 'classnames';

type Props = ComponentProps<typeof PlcCell> & {
  element?: ReactNode | null;
  unit?: string;
  header?: 'headerInRow' | 'headerInHeader';
};

const StocksTableCell: FC<Props> = ({ header, element, unit, className, ...rest }) => {
  const rootClass = classnames(className);
  const content = (
    <>
      {element === undefined || element === null ? '-' : element}
      {unit && ` ${unit}`}
    </>
  );
  return header ? (
    <PlcHeaderCell className={rootClass} header={header === 'headerInHeader'} {...rest}>
      {content}
    </PlcHeaderCell>
  ) : (
    <PlcCell className={rootClass} {...rest}>
      {content}
    </PlcCell>
  );
};

export { StocksTableCell };
